import { useState } from "#imports";
export function useVisitedRoutes() {
  const visitedRoutes = useState("i18n-visited-routes-hash", () => []);
  function visitRoute(routeHash) {
    if (visitedRoutes.value.includes(routeHash)) {
      return;
    }
    visitedRoutes.value.push(routeHash);
  }
  function hasBeenVisited(routeHash) {
    return visitedRoutes.value.includes(routeHash);
  }
  return {
    hasBeenVisited,
    visitRoute
  };
}
